module.exports = __webpack_public_path__ + "img/cricket-icon-red.957b5944.png";